<template>
    <div>
        <apexchart width="95%" height="190" type="bar" :options="chartOptions" :series="series" ref="barChart"></apexchart>
    </div>
</template>
<script>
    export default {
        name: 'bar-chart',
        props: {
            data: {
                type: Array
            },
            categories: {
                type: Array
            }
        },
        data () {
            return {
                series: [{
                    data: this.data
                }],
                chartOptions: {
                    dataLabels: {
                        enabled: true,
                        textAnchor: 'start',
                        style: {
                            fontSize: '11px',
                            fontFamily: 'Nunito-Regular, sans-serif',
                            colors: ['#fff'],
                            fontWeight: 'normal'
                        },
                        formatter: function (val, opt) {
                            if (val === 0) {
                                return val + 'min'
                            }

                            let hours = Math.floor(val / 60)
                            let minutes = val % 60
                            hours = hours !== 0 ? hours + 'h ' : ''
                            minutes = minutes !== 0 ? minutes + 'min' : ''

                            return hours + minutes
                        },
                        offsetX: 0,
                        dropShadow: {
                            enabled: false
                        },
                        background: {
                            enabled: true,
                            foreColor: '#000',
                            borderColor: '#fafafa',
                            borderWidth: 10,
                            opacity: 1,
                            borderRadius: 0,
                            padding: 5
                        }
                    },
                    xaxis: {
                        show: true,
                        axisBorder: {
                            show: false
                        },
                        axisTicks: {
                            show: false
                        },
                        labels: {
                            show: false
                        },
                        categories: []
                    },
                    yaxis: {
                        show: true,
                        labels: {
                            show: true,
                            style: {
                                fontFamily: 'Nunito-Regular, sans-serif',
                                fontSize: '13px'
                            }
                        },
                        axisBorder: {
                            show: false
                        },
                        axisTicks: {
                            show: false
                        }
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true,
                            barHeight: '25',
                            distributed: true,
                            dataLabels: {
                                position: 'middle'
                            }
                        }
                    },
                    legend: {
                        show: false
                    },
                    theme: {
                        monochrome: {
                            enabled: false,
                            color: '#E47700',
                            shadeTo: 'light',
                            shadeIntensity: 0.65
                        }
                    },
                    grid: {
                        show: false,
                        xaxis: {
                            lines: {
                                show: false
                            }
                        },
                        yaxis: {
                            lines: {
                                show: false
                            }
                        }
                    },
                    chart: {
                        id: 'bar-chart',
                        toolbar: {
                            show: false
                        }
                    },
                    tooltip: {
                        enabled: false
                    },
                    states: {
                        hover: {
                            filter: {
                                type: 'none'
                            }
                        }
                    },
                    colors: ['#E47700', '#E99233', '#EFAD66', '#F4C999', '#FAE4CC']
                }
            }
        },
        methods: {
            updateSeries () {
                ApexCharts.exec('bar-chart', 'updateSeries', [
                    {
                        data: this.data
                    }
                ])
            },
            updateXaxis () {
                ApexCharts.exec('bar-chart', 'updateOptions', {
                    xaxis: {
                        categories: this.categories
                    }
                })
            }
        },
        watch: {
            data: {
                handler: 'updateSeries'
            },
            categories: {
                handler: 'updateXaxis'
            }
        },
        beforeDestroy () {
            this.$refs.barChart.$destroy()
        }
    }
</script>

<style lang="scss">
    .apexchartsbar-chart {
        > svg {
            overflow: visible;
        }
    }
</style>
